import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import store from '@/store';
import fb from '@/firebaseConfig';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: 'Welcome' },
    component: Home,
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: 'About',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: 'Register',
    },
    component: () => import(/* webpackChunkName: "register" */ '@/views/Register.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Log in',
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {
      title: 'User Profile',
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
  },
  {
    path: '/assets',
    name: 'assets',
    meta: {
      title: 'Assets',
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "assets" */ '@/views/Assets.vue'),
  },
  {
    path: '/import',
    name: 'import',
    meta: {
      title: 'Import Images',
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "assets" */ '@/views/Import.vue'),
  },
  {
    path: '/markup',
    name: 'markup',
    meta: {
      title: 'Markup Images',
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "assets" */ '@/views/Markup.vue'),
  },
  {
    path: '/dropboxoauth',
    name: 'dropboxoauth',
    meta: {
      title: 'Dropbox OAuth',
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "dropboxoauth" */ '@/views/DropboxOAuth.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = fb.auth.currentUser;

  // from https://alligator.io/vuejs/vue-router-modify-head/
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = store.getters.site.title + ' - ' + nearestWithTitle.meta.title;
  }

  if (requiresAuth && !isAuthenticated) {
    next('/login');
  } else {
    next();
  }
});

export default router;
